import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  TextField,
  Alert,
  CircularProgress
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { Colors } from "../utils/colors";
import { API } from "../constant/apiConstant";

export default function AdminVerifyResetOtp() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    type: "info",
    message: ""
  });

  const showAlert = (type, message, time = 5000) => {
    setAlert({
      show: true,
      type,
      message
    });

    setTimeout(() => {
      setAlert((prev) => ({ ...prev, show: false }));
    }, time);
  };

  const verifyOTP = async () => {
    setLoading(true);

    try {
      const res = await fetch(`${API.BASE_URL}/api/admin/auth/forgot-password/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          otp
        })
      });

      const data = await res.json();

      if (!data.status) {
        showAlert("error", data.message || "Invalid OTP");
        setLoading(false);
        return;
      }

      showAlert("success", "OTP verified successfully");

      setTimeout(() => {
        navigate("/reset-password", { state: { email, isAdminReset: true } });
      }, 1200);
    } catch (error) {
      showAlert("error", "Unable to verify OTP");
    }

    setLoading(false);
  };

  const resendOTP = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api/admin/auth/forgot-password/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      const data = await res.json();

      if (!data.status) {
        showAlert("error", data.message || "Unable to resend OTP");
        return;
      }

      showAlert("success", "OTP sent again to your admin email");
    } catch (error) {
      showAlert("error", "Unable to resend OTP");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: Colors.secondary,
        p: 2
      }}
    >
      <Card sx={{ p: 4, width: "100%", maxWidth: 520, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight={700} sx={{ color: Colors.accent }}>
          Verify OTP
        </Typography>

        {alert.show && (
          <Alert severity={alert.type} sx={{ mt: 2 }}>
            {alert.message}
          </Alert>
        )}

        <TextField label="Admin Email" fullWidth sx={{ mt: 2 }} value={email} disabled />

        <TextField
          label="Enter OTP"
          fullWidth
          sx={{ mt: 2 }}
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, backgroundColor: Colors.secondary, color: "white" }}
          onClick={verifyOTP}
          disabled={otp.length < 4 || loading}
        >
          {loading ? <CircularProgress size={22} sx={{ color: "white" }} /> : "Verify OTP"}
        </Button>

        <Typography
          sx={{
            mt: 2,
            textAlign: "center",
            color: Colors.accent,
            fontSize: 14,
            cursor: "pointer",
            fontWeight: 600
          }}
          onClick={resendOTP}
        >
          Resend OTP
        </Typography>
      </Card>
    </Box>
  );
}
